import SVGIcon from '../../assets/images/svg/SVGIcon';
import { TASK_PRIORITY_LABELS, TASK_PRIORITY } from '../../global/constants';
import { STATUS_TYPE } from '../../global/constants';
import { renderStatusIconName, renderPriorityIconName } from '../../helpers/common';
import { rootStore } from '../../mobx/rootStore';
import { dispatchTaskError, dispatchTaskSuccess } from '../../services/taskServices';
import Avatar from '../avatar/Avatar';
import { Dropdown, DropdownItem } from '../Dropdown';
import copy from 'clipboard-copy';
import {
  AvtarDiv,
  BackArrowIcon,
  Dropdiv,
  IconDiv,
  TaskLinkContainer,
  TaskLinkContent,
  TaskLinkPreviewMainDiv,
  TaskLinkWrapper,
  TaskProjectName,
  TaskStatus,
  TaskTabSection,
  TaskTitle
} from './style';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

interface TaskLinkEmbedProps {
  node: {
    attribs: {
      taskid: string;
      projectname: string;
      taskname: string;
      statusname: string;
      priorityname: string;
      url: string;
      assigneeUrls: string;
      assigneeName: string;
    };
  };
}

const TaskLinkEmbedCard = ({ node }: TaskLinkEmbedProps) => {
  const taskId = node.attribs.taskid || '';
  const url = node.attribs.url;

  // Mobx store variables
  const { projectStore, taskStore } = rootStore || {};
  const { projects } = projectStore || {};
  const { tasks } = taskStore || {};
  const taskDetails = tasks?.find((task) => task.id === taskId);

  //Other variables
  const history = useHistory();

  const defaultStatus = taskDetails?.project?.statusData?.find((status: any) => status?.Default);
  const status =
    taskDetails?.project?.statusData?.find((status: any) => status['_id'] === taskDetails?.statusId) || defaultStatus;
  const priorityName = taskDetails?.priority ? TASK_PRIORITY_LABELS[taskDetails?.priority] : node.attribs.priorityname;
  const priorityType = taskDetails?.priority || TASK_PRIORITY.NO_PRIORITY;
  const priorityIconClass = renderPriorityIconName(priorityType);
  const statusType = status?.Type || STATUS_TYPE.UNSTARTED;
  const statusIconClass = renderStatusIconName(statusType);
  const projectName = taskDetails?.project?.name || node.attribs.projectname;
  const taskName = taskDetails?.name || node.attribs.taskname;
  const statusName = status?.Name || node.attribs.statusname;

  const assigneeUrlArray = node.attribs.assigneeUrls?.split(',') || [];
  const assigneeNameArray = node.attribs.assigneeName?.split(',') || [];

  const assigneeUrls =
    taskDetails?.users?.map((user) => user?.profile_photo || 'https://randomuser.me/api/portraits/men/1.jpg') ||
    assigneeUrlArray;

  const onClickCopyProjectLink = async (url: string) => {
    await copy(url);
    dispatchTaskSuccess('Task url copied successfully!');
  };

  const onClickCard = useCallback(() => {
    const projectId = url.split('/projects/details/')[1]?.split('/tasks')[0];
    const path = new URL(url).pathname;
    const projectDetails = projects?.find((project) => project.id === projectId);
    if (projectDetails) {
      rootStore.projectStore.setCurrentProject(projectId);
      history.push(path);
    } else dispatchTaskError(`You don't have access for this task`);
  }, [history, projects, url]);

  return (
    <TaskLinkPreviewMainDiv data-name={taskId} onClick={onClickCard}>
      <TaskLinkContainer>
        <TaskLinkContent>
          <TaskLinkWrapper>
            <TaskProjectName>{projectName || 'TeamCamp Web'}</TaskProjectName>
            <TaskTitle>
              {taskName || 'Task Link'}
              <BackArrowIcon>
                <SVGIcon
                  name='report-right-arrow-icon'
                  width='16'
                  height='16'
                  viewBox='0 0 18 18'
                  stroke='var(--text-secondary)'
                />
              </BackArrowIcon>
            </TaskTitle>
          </TaskLinkWrapper>
          <Dropdiv>
            <Dropdown
              activeClassName='active-dropdown'
              content={
                <IconDiv>
                  <SVGIcon name='task-detail-dot-icon' width='16' height='16' viewBox='0 0 18 18' />
                </IconDiv>
              }
              trigger='click'>
              <DropdownItem
                label='Copy link'
                iconName='copy-link-icon'
                onClick={() => onClickCopyProjectLink(node.attribs.url)}
                iconViewBox='0 0 18 18'
              />
            </Dropdown>
          </Dropdiv>
        </TaskLinkContent>
        <TaskTabSection>
          {/* Status */}
          <TaskStatus>
            {/* DO CODE FOR STATUS SHOW */}
            <SVGIcon name={statusIconClass} width='14' height='14' viewBox='0 0 16 16' fill='none' />
            <span className='status-name'>{statusName || 'TODO'}</span>
          </TaskStatus>
          {/* Priority */}
          {taskDetails?.project?.priority?.enabled && (
            <TaskStatus>
              <SVGIcon name={priorityIconClass} width='14' height='14' viewBox='0 0 16 16' fill='none' />
              <span className='status-name'>{priorityName || 'No Priority'}</span>
            </TaskStatus>
          )}
          {/* Assignee */}
          <TaskStatus className='task-assignee task-avtar'>
            {assigneeUrls?.map((item, index) => (
              <AvtarDiv style={{ marginLeft: index > 0 ? '-12px' : '0' }}>
                <Avatar imgSrc={item} name={assigneeNameArray[index]} size={16} />
              </AvtarDiv>
            ))}
            {assigneeUrls?.length === 1 && (
              <span className='status-name'>{taskDetails?.users[0]?.name || assigneeNameArray[0] || 'Unknown'}</span>
            )}
          </TaskStatus>
        </TaskTabSection>
      </TaskLinkContainer>
    </TaskLinkPreviewMainDiv>
  );
};

export default TaskLinkEmbedCard;
